import React from 'react';
import ReactDOMServer from 'react-dom/server';
import ReturnReceipt, { ReturnReceiptData } from '../components/return/return-receipt';
import { openPrintWindow, writeAndPrint } from './printWindow';

/** Нэг буцаалтын баримтын дэлгэрэнгүй (`GET mongol/return/:returnId`). */
export async function fetchReturnReceipt(apiUrl: string, token: string, returnId: number): Promise<ReturnReceiptData> {
  const res = await fetch(apiUrl + 'mongol/return/' + returnId, {
    method: 'GET',
    headers: { Accept: 'application/json', Authorization: token, 'Content-Type': 'application/json' },
  });
  if (!res.ok) {
    throw new Error(`return ${returnId}: HTTP ${res.status}`);
  }
  const data: any = await res.json();
  return { header: data.header, rows: Array.isArray(data.rows) ? data.rows : [] };
}

function buildReturnReceiptPageHtml(receipt: ReturnReceiptData): string {
  return ReactDOMServer.renderToStaticMarkup(
    React.createElement(
      'div',
      { className: 'batch-receipt-page page-order' },
      React.createElement(ReturnReceipt, { receipt })
    )
  );
}

export type PrintReturnReceiptsParams = {
  apiUrl: string;
  token: string;
  returnIds: number[];
};

export type PrintReturnReceiptsResult = { ok: true } | { ok: false; error: 'popup' | 'network' };

/**
 * Буцаалтын баримт(ууд)-ыг хүргэлтийн баримттай ижил popup-аар хэвлэнэ, баримт бүр тусдаа
 * хуудсанд. Click handler-аас шууд дуудна — popup нь ямар ч `await`-аас өмнө нээгдэх ёстой.
 */
export async function printReturnReceipts(params: PrintReturnReceiptsParams): Promise<PrintReturnReceiptsResult> {
  const w = openPrintWindow();
  if (!w) {
    return { ok: false, error: 'popup' };
  }
  try {
    const receipts = await Promise.all(
      params.returnIds.map((returnId) => fetchReturnReceipt(params.apiUrl, params.token, returnId))
    );
    writeAndPrint(w, {
      title: 'Буцаалтын баримт',
      bodyHtml: receipts.map(buildReturnReceiptPageHtml).join('\n'),
    });
    return { ok: true };
  } catch {
    w.close();
    return { ok: false, error: 'network' };
  }
}
